exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bathroom-checkBox {\r\n  width: 70px;\r\n}\r\n.imagediv li {\r\n  text-align: center;\r\n}\r\n.categories-checkBox {\r\n    width: 172px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Web/Dubai/DubaisaleV1/cpapi.v1/CPDubaisaleApp/src/app/projectsManagement/project/set-project/set-project.component.css
// module id = ../../../../../src/app/projectsManagement/project/set-project/set-project.component.css
// module chunks = main